import { MailCheck } from "lucide-react";
import { cn } from "@/utils";

interface EmailAffordanceCardProps {
  email: string;
  title: string;
  helperText: string;
  buttonIdleText: string;
  isCoolingDown: boolean;
  isResending: boolean;
  secondsLeft: number;
  onResend: () => void;
  className?: string;
}

export default function EmailAffordanceCard({
  email,
  title,
  helperText,
  buttonIdleText,
  isCoolingDown,
  isResending,
  secondsLeft,
  onResend,
  className,
}: EmailAffordanceCardProps) {
  return (
    <div
      className={cn(
        "mt-6 rounded-lg border border-startfly-gold/30 bg-startfly-gold/5 p-4",
        className
      )}
    >
      <div className="flex gap-3">
        <MailCheck className="h-5 w-5 shrink-0 text-startfly-gold" />
        <div className="flex-1 text-left">
          <p className="text-sm font-semibold text-startfly-black">
            {title}
          </p>
          <p className="mt-0.5 text-sm text-startfly-gray break-all">
            {email}
          </p>
          <p className="mt-2 text-xs text-startfly-gray">{helperText}</p>
          <button
            type="button"
            disabled={isCoolingDown || isResending}
            onClick={onResend}
            className="mt-3 text-sm font-medium text-startfly-gold hover:underline disabled:opacity-50 disabled:no-underline disabled:cursor-not-allowed"
          >
            {isCoolingDown ? `${buttonIdleText} (${secondsLeft}s)` : buttonIdleText}
          </button>
        </div>
      </div>
    </div>
  );
}
